import { AccordionContent, AccordionTrigger } from '@/components/ui/accordion'

import { AccordionItem } from '@/components/ui/accordion'

export const FilterItemAccordion = ({
  title,
  children,
  value,
}: {
  title: string
  children: React.ReactNode
  value: string
}) => {
  return (
    <AccordionItem
      value={value}
      className='border-b border-b-neutral-200 pb-4.5 lg:border-0 lg:p-0 lg:pb-0'
    >
      <AccordionTrigger className='py-1.5 font-sans text-sm font-medium leading-4.5 text-neutral-400 lg:py-3'>
        {title}
      </AccordionTrigger>
      <AccordionContent className='py-1.5 lg:pt-3'>{children}</AccordionContent>
    </AccordionItem>
  )
}
